import { Button } from "../../components/Button";
import { Section } from "../../components/Section";
import { SectionSubTitle, SectionTitle } from "../../components/SectionTitle";
import { Spacer } from "../../components/Spacer";
import { SubSection } from "../../components/SubSection";
import { TipsSvg } from "../../components/Svg/Icons/Tips";
import { FadeUp } from "../../components/Transitions/FadeUp";
import { Contact } from "./Contact";

export const Form = () => {
  return (
    <Section className="bg-primary-light">
      <FadeUp>
        <SectionTitle
          title="Confirma tu asistencia"
          subtitle="Necesitamos que dediques 5 minutos a contestar estas preguntas para
          ayudarnos a organizarnos."
          textColor="text-secondary-light"
          eyeBrow
        />
        <Spacer />
        <Spacer />
        <div className="max-w-90 m-auto">
          <div className="text-center text-secondary-light font-semibold">
            Sólo adultos 😉
          </div>
          <Spacer />
          <Button
            bgColor="white"
            borderColor="primary-text"
            textColor="primary-text"
            to={{
              href: "https://docs.google.com/forms/d/e/1FAIpQLSfHPuXFsvoyUleN7OEJe0jwXGW6eDUGMDjIhfMyPqeqil7kfQ/viewform?usp=header",
              target: "_blank",
            }}
            icon={<TipsSvg width="45px" color="var(--color-primary-text)" />}
          >
            Llévame al formulario
          </Button>
        </div>
      </FadeUp>

      <SubSection>
        <FadeUp>
          <SectionSubTitle
            title="¡Os esperamos!"
            subtitle="Gracias por acompañarnos en el comienzo de esta maravillosa aventura."
            textColor="text-secondary-light"
          />
          <Spacer />
          <Spacer />
          <div className="max-w-200 flex justify-center m-auto">
            <img
              src="/ellos_corazon.png"
              alt="Heart"
              width={920}
              className="soft-card rounded-4xl p-3"
            />
          </div>
        </FadeUp>
      </SubSection>

      <SubSection>
        <Contact />
      </SubSection>
    </Section>
  );
};
